import { SnackbarProvider } from 'notistack';
import { Clear } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';
import CheckmarkIcon from 'assets/checkmark.svg?react';
import InfoIcon from 'assets/info.svg?react';
import ExclamationIcon from 'assets/exclamation.svg?react';
import { WatchDutySnackbarContent } from '../WatchDutySnackbarContent';

const DEFAULT_HIDE_TIME_MS = 3000;

const useStyles = makeStyles()((theme) => ({
  customContainerRoot: {
    top: `calc(env(safe-area-inset-top) + 65px) !important`,
  },
  customRoot: {
    marginTop: theme.spacing(1),
  },
}));

const commonSvgIconStyle = { marginTop: '2px', width: '24px' };

export const WatchDutySnackbarProvider = (): JSX.Element => {
  const { classes } = useStyles();
  return (
    <SnackbarProvider
      autoHideDuration={DEFAULT_HIDE_TIME_MS}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      Components={{
        default: WatchDutySnackbarContent,
        success: WatchDutySnackbarContent,
        error: WatchDutySnackbarContent,
        warning: WatchDutySnackbarContent,
        info: WatchDutySnackbarContent,
      }}
      iconVariant={{
        default: null,
        success: <CheckmarkIcon style={commonSvgIconStyle} />,
        error: <Clear fontSize="small" sx={commonSvgIconStyle} />,
        warning: <ExclamationIcon style={commonSvgIconStyle} />,
        info: <InfoIcon style={commonSvgIconStyle} />,
      }}
      classes={{
        containerRoot: classes.customContainerRoot,
        root: classes.customRoot,
      }}
      dense
    />
  );
};
